// removed by extract-text-webpack-plugin
module.exports = {"label":"label__2C3-WdNktguh","content":"content__1hJ7xRJ9b2ag","expandIcon":"expandIcon__3U09TQYJug0H","isOpen":"isOpen__23c83wruAqrZ"};